import { call, put, select, takeLatest } from 'redux-saga/effects';
import makeSagaRequest from 'app/shared/sagas/makeSagaRequest';

// Models
import { GoAMLActionTypes } from 'app/modules/goAML/models';

// Actions
import {
  createGoAMLFiling as createGoAMLFilingAction,
  createGoAMLFilingSuccess,
} from 'app/modules/goAML/actions';

// API
import { createGoAMLFiling as createGoAMLFilingAPI } from 'app/shared/api/goAML';

// Selectors
import { selectDLEnabledForGoAMLCreate } from 'app/shared/featureFlags/selectors';

// Utils
import routes from 'app/shared/utils/routes';
import { history } from 'app/store/browserHistory';

const rootAction = GoAMLActionTypes.CREATE_GOAML_FILING;
export function* createGoAMLFiling({
  payload,
}: ReturnType<typeof createGoAMLFilingAction>) {
  const goAMLCreateCacheEnabled: boolean = yield select(
    selectDLEnabledForGoAMLCreate,
  );
  const txs = payload.transactions;
  const cachedBodyOk = !txs?.length || txs.every((t) => Boolean(t.external_id));
  const useCachedEndpoint =
    payload.case_id != null && goAMLCreateCacheEnabled && cachedBodyOk;

  const config = {
    rootAction,
    errorToastMessage: 'Something went wrong, unable to create goAML report.',
    request: call(createGoAMLFilingAPI, payload, useCachedEndpoint),
    success: function* onSuccess(
      result: ReturnType<typeof createGoAMLFilingSuccess>['payload'],
    ) {
      yield put(createGoAMLFilingSuccess(result));

      // Redirect to edit view
      history.push(
        routes.lumos.filingsGoAMLIdEdit.replace(':id', `${result.id}`),
      );
    },
  };

  yield call(makeSagaRequest, config);
}

export default function* watch() {
  yield takeLatest(rootAction, createGoAMLFiling);
}
